import { render, staticRenderFns } from "./alert-general.vue?vue&type=template&id=51e32450"
import script from "./alert-general.vue?vue&type=script&lang=js"
export * from "./alert-general.vue?vue&type=script&lang=js"
import style0 from "./alert-general.vue?vue&type=style&index=0&id=51e32450&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports